import React, { useState, useEffect } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import {
  makeStyles,
  IconButton,
  InputAdornment,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TablePagination,
  Checkbox,
  Box,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import People from "@material-ui/icons/People";
import TrendingMastersView from "./TrendingMastersView";
import TrendingMastersAdd from "./TrendingMastersAdd";
import TrendingMastersEdit from "./TrendingMastersEdit";
import { DeleteTrendingAPI, GetAllTrendingAPI } from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ImportExcel } from "../Master/ImportExcel";
import { CloudDownload, CloudUpload } from "@material-ui/icons";
import * as XLSX from 'xlsx';
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "readyMasterRangeId", label: "Product" },
  { id: "action", label: "Action" },
];

export default function TrendingMastersList(props) {
  const classes = useStyles();
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [trending, setTrending] = useState([]);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    _getTrending();
  }, [openAddDialog, openEditDialog]);

  async function _getTrending() {
    try {
      let res = await axios.get(GetAllTrendingAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log(res.data, "My trendin")
      setTrending(res.data.trendingMaster);
    } catch (err) {
      // console.log(err);
    }
  }

  async function _deleteItem(item) {
    try {
      let res = await axios.delete(
        DeleteTrendingAPI(item._id),

        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      toast.success('Successfully Deleted!', {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getTrending();
      // window.location.reload();
    } catch (e) {
      // console.log("err:", e);
    }
  }

  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeAddDialog() {
    setOpenAddDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  let data = trending;

  // Export function
  const handleExport = async () => {
    setIsExporting(true);
    const loadingToastId = toast.loading('🔄 Preparing export... Please wait', {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });

    try {
      // First, get the total count
      toast.update(loadingToastId, {
        render: '📊 Fetching total record count...',
        type: 'info',
        isLoading: true,
      });

      const totalRes = await axios.get(GetAllTrendingAPI(userInfo.entity) + `&limit=1&skip=0`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const total = totalRes.data.total || (totalRes.data.trendingMaster?.length || 0);
      
      if (total === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      // Fetch all data using the total count
      toast.update(loadingToastId, {
        render: `📥 Downloading ${total} records... This may take a moment`,
        type: 'info',
        isLoading: true,
      });

      const res = await axios.get(GetAllTrendingAPI(userInfo.entity) + `&limit=${total}&skip=0`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const allData = res.data.trendingMaster || [];
      if (!allData || allData.length === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      toast.update(loadingToastId, {
        render: '⚙️ Processing data for export...',
        type: 'info',
        isLoading: true,
      });

      const exportHeadings = [
        { id: "readyMasterRangeId", label: "Product" }
      ];

      const exportData = allData.map(row => {
        const rowData = {};
        exportHeadings.forEach(col => {
          let value = row[col.id];
          if (col.id === 'readyMasterRangeId' && value && value.productName) {
            value = value.productName;
          }
          rowData[col.id] = value;
        });
        return rowData;
      });

      toast.update(loadingToastId, {
        render: '💾 Generating Excel file...',
        type: 'info',
        isLoading: true,
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Trending');
      XLSX.writeFile(workbook, 'trending_export.xlsx');

      toast.update(loadingToastId, {
        render: `✅ Successfully exported ${allData.length} records to Excel!`,
        type: 'success',
        isLoading: false,
        autoClose: 4000,
        style: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } catch (error) {
      console.error('Export error:', error);
      toast.update(loadingToastId, {
        render: `❌ Export failed: ${error.response?.data?.message || error.message || 'Unknown error'}`,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        style: {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 className={classes.cardTitleWhite}>Trending</h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <CustomInput
                  id="search"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    style: {
                      marginTop: 0,
                      marginRight: 10,
                      color: "white",
                    },
                    placeholder: "Search",
                    value: searchTerm,
                    onChange: (e) => setSearchTerm(e.target.value),
                    endAdornment: (
                      <InputAdornment position="end">
                        <People />
                      </InputAdornment>
                    ),
                  }}
                />
                <IconButton
                  aria-label="add"
                  style={{ color: "white" }}
                  onClick={() => setOpenAddDialog(true)}
                >
                  <AddIcon />
                </IconButton>
              </div>
            </div>
          </CardHeader>

          <CardBody>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <Checkbox
                    style={{
                      color: "#512da8",
                    }}
                    onChange={(e) => {
                      let c = [];
                      if (e.target.checked) {
                        data.map((i) => {
                          c.push(i._id);
                        });
                      }
                      setSelectedRows(c);
                    }}
                    checked={
                      selectedRows.length > 0 &&
                      data.length === selectedRows.length
                    }
                    inputProps={{ "aria-labelledby": -1 }}
                  />
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={"center"}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            style={{
                              color: "#512da8",
                            }}
                            onChange={() => {
                              let copy = _.clone(selectedRows);
                              if (_.includes(copy, row._id)) {
                                let index = _.indexOf(copy, row._id);
                                copy.splice(index, 1);
                              } else {
                                copy.push(row._id);
                              }
                              setSelectedRows(copy);
                            }}
                            checked={_.includes(selectedRows, row._id)}
                            inputProps={{ "aria-labelledby": row._id }}
                          />
                        </TableCell>
                        {columns.map((column) => {
                          const value = row[column.id];

                          if (column.id === "action") {
                            return (
                              <TableCell align={"center"}>
                                <Box display={"flex"} justifyContent={"center"}>
                                  {/* <IconButton
                                    onClick={() =>
                                      setOpenViewDialog({
                                        open: true,
                                        item: row,
                                      })
                                    }
                                    aria-label="view"
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() =>
                                      setOpenEditDialog({
                                        open: true,
                                        item: row,
                                      })
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton> */}
                                  <IconButton
                                    onClick={() =>
                                      handleOpenConfirmationModal({
                                        title: "Delete Record",
                                        msg: "Do you want to delete this record?",
                                        onPress: () => _deleteItem(row),
                                      })
                                    }
                                    aria-label="delete"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            );
                          }

                          if (column.id === "readyMasterRangeId") {
                            return (
                              <TableCell key={column.id} align={"center"}>
                                {value?.productName}
                              </TableCell>
                            );
                          }

                          return (
                            <TableCell key={column.id} align={"center"}>
                              {column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardBody>
        </Card>
      </GridItem>
      {openViewDialog ? (
        <TrendingMastersView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openAddDialog ? (
        <TrendingMastersAdd open={openAddDialog} close={closeAddDialog} />
      ) : null}

      {openEditDialog ? (
        <TrendingMastersEdit
          open={openEditDialog}
          close={closeEditDialog}
          item={openEditDialog.item}
        />
      ) : null}

      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={"Delete Record"}
          msg={"Do you want to delete this record?"}
        />
      ) : null}
      <ImportExcel
        db={"trendingMasters"}
        open={openImportDialog}
        close={() => {
          setOpenImportDialog(false);
          _getTrending();
        }}
      />
      <Backdrop
        open={isExporting}
        style={{
          zIndex: 9999,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={60} thickness={4} style={{ color: '#512da8', marginBottom: 20 }} />
          <Box style={{ fontSize: '18px', fontWeight: 'bold', marginTop: 10 }}>
            Exporting Data...
          </Box>
          <Box style={{ fontSize: '14px', marginTop: 5, opacity: 0.8 }}>
            Please wait while we prepare your Excel file
          </Box>
        </Box>
      </Backdrop>
    </GridContainer>
  );
}
